import React from "react";
import { motion } from "framer-motion";
import { crmPipelineKpis } from "../../data/crmPageContent";
import { CrmPipelineDashboard } from "./CrmMockups";
import { CrmReveal, CrmStagger, CrmStaggerItem } from "./CrmMotion";

export const CrmPipelineSection = () => (
    <section className="crm-pipeline-v2">
        <div className="crm-container">
            <CrmReveal className="crm-pipeline-v2__header">
                <h2 className="crm-h2">Smart Sales Pipeline</h2>
                <div className="crm-section-accent crm-section-accent--center" />
                <p className="crm-lead">
                    A dashboard-style pipeline with real-time counts, values, and conversion insights
                    at every stage — from new leads to closed deals.
                </p>
            </CrmReveal>

            <CrmReveal delay={0.08}>
                <CrmPipelineDashboard />
            </CrmReveal>

            <CrmStagger className="crm-pipeline-v2__kpis">
                {crmPipelineKpis.map((kpi) => (
                    <CrmStaggerItem key={kpi.label}>
                        <motion.div className="crm-pipeline-v2__kpi" whileHover={{ y: -4 }}>
                            <span className="crm-pipeline-v2__kpi-label">{kpi.label}</span>
                            <strong>{kpi.value}</strong>
                            <em>{kpi.change}</em>
                        </motion.div>
                    </CrmStaggerItem>
                ))}
            </CrmStagger>
        </div>
    </section>
);
